import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star } from 'lucide-react';
import { Button } from './ui/Button';
export function Pricing() {
  return <section id="pricing" className="py-24 bg-slate-50" data-id="element-186">
      <div className="container mx-auto px-4" data-id="element-187">
        <div className="text-center mb-16" data-id="element-188">
          <h2 className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-4" data-id="element-189">
            ELEGÍ TU CENTRALPACK
          </h2>
          <p className="text-xl text-slate-600" data-id="element-190">
            Asegurá tu acceso antes de que termine el contador.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto items-center" data-id="element-191">
          {/* Standard Tier */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl p-8 shadow-lg border border-slate-200 flex flex-col h-full" data-id="element-192">
            <div className="mb-6" data-id="element-193">
              <h3 className="text-2xl font-bold text-slate-900 mb-2 flex items-center gap-2" data-id="element-194">
                🤟 MEGAPACK LSA LISTO
              </h3>
              <p className="text-blue-600 font-bold" data-id="element-195">6 Tomos + 4 Bonos</p>
            </div>

            <div className="mb-6 pb-6 border-b border-slate-100" data-id="element-196">
              <p className="text-sm text-slate-500 mb-2" data-id="element-197">Ideal para:</p>
              <p className="text-slate-700 font-medium" data-id="element-198">
                Quien quiere aprender LSA desde cero de manera completa y
                progresiva
              </p>
            </div>

            <div className="mb-8" data-id="element-199">
              <p className="text-slate-400 line-through text-lg mb-1" data-id="element-200">
                $49.000
              </p>
              <div className="flex items-end gap-2" data-id="element-201">
                <span className="text-5xl font-black text-slate-900" data-id="element-202">
                  $19.990
                </span>
                <span className="text-xl font-bold text-slate-500 mb-1" data-id="element-203">
                  ARS
                </span>
              </div>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-204">
              {['6 Tomos completos (Nivel 0 a Avanzado)', '4 Bonos Estratégicos', 'Acceso de por vida', 'Actualizaciones gratuitas'].map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-205">
                  <Check className="w-5 h-5 text-blue-500 shrink-0 mt-0.5" data-id="element-206" />
                  <span className="text-slate-700" data-id="element-207">{feature}</span>
                </li>)}
            </ul>

            <a href="https://www.centralpack.shop/cart/53517037601086:1" target="_blank" rel="noopener noreferrer" className="block" data-id="element-208">
              <Button variant="secondary" size="lg" fullWidth withArrow data-id="element-209">
                QUIERO MI CENTRALPACK AHORA
              </Button>
            </a>
          </motion.div>

          {/* Pro Tier */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-slate-900 rounded-3xl p-8 shadow-2xl border-2 border-amber-400 flex flex-col h-full relative lg:scale-105 z-10" data-id="element-210">
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-amber-400 text-slate-900 px-4 py-1.5 rounded-full font-bold text-sm flex items-center gap-1.5 whitespace-nowrap shadow-lg" data-id="element-211">
              <Star className="w-4 h-4 fill-slate-900" data-id="element-212" /> MÁS ELEGIDO
            </div>

            <div className="mb-6 mt-2" data-id="element-213">
              <h3 className="text-2xl font-bold text-white mb-2 flex items-center gap-2" data-id="element-214">
                🚀 MEGAPACK LSA + PROFESIONAL
              </h3>
              <p className="text-amber-400 font-bold" data-id="element-215">
                6 Tomos + 4 Bonos + LSA Profesional
              </p>
              <p className="text-slate-400 text-sm mt-1" data-id="element-216">
                (vocabulario técnico especializado)
              </p>
            </div>

            <div className="mb-6 pb-6 border-b border-slate-700" data-id="element-217">
              <p className="text-sm text-slate-400 mb-2" data-id="element-218">Ideal para:</p>
              <p className="text-slate-200 font-medium" data-id="element-219">
                Médicos, docentes, empleados bancarios, abogados, comerciantes y
                profesionales que necesitan LSA técnico en su entorno laboral
              </p>
            </div>

            <div className="mb-8" data-id="element-220">
              <p className="text-slate-500 line-through text-lg mb-1" data-id="element-221">
                $69.000
              </p>
              <div className="flex items-end gap-2" data-id="element-222">
                <span className="text-5xl font-black text-white" data-id="element-223">$27.990</span>
                <span className="text-xl font-bold text-slate-400 mb-1" data-id="element-224">
                  ARS
                </span>
              </div>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-225">
              <li className="flex items-start gap-3" data-id="element-226">
                <Check className="w-5 h-5 text-amber-400 shrink-0 mt-0.5" data-id="element-227" />
                <span className="text-white font-bold" data-id="element-228">
                  Todo lo del MegaPack LSA Listo, MÁS:
                </span>
              </li>
              {['Módulo Salud (Anatomía, Farmacología, etc)', 'Módulo Educación (Consignas, Psicopedagogía)', 'Módulo Banca y Comercio (Inversiones, RRHH)', 'Módulo Legal (Derechos, Denuncias, Mediación)'].map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-229">
                  <Check className="w-5 h-5 text-amber-400 shrink-0 mt-0.5" data-id="element-230" />
                  <span className="text-slate-300" data-id="element-231">{feature}</span>
                </li>)}
            </ul>

            <a href="https://www.centralpack.shop/cart/53517061062974:1" target="_blank" rel="noopener noreferrer" className="block" data-id="element-232">
              <Button variant="primary" size="lg" fullWidth withArrow className="text-lg" data-id="element-233">
                QUIERO EL MEGAPACK + PROFESIONAL
              </Button>
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}